import { all, takeLatest, call } from 'redux-saga/effects'
import getAllowanceCardDesign from 'services/allowance-card-design'
import fetchData from '../helpers/fetchData'
import actions from './actions'

function* fetchAllowanceCardDesign({ payload }) {
  const service = () => getAllowanceCardDesign(payload)
  yield call(fetchData, actions.allowanceCardDesignApiName, service)
}

export default function* rootSaga() {
  yield all([takeLatest(actions.requestAllowanceCardDesign, fetchAllowanceCardDesign)])
}
